var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80007 7.9C3.53007 7.31 2.80007 6.7 2.80007 5.75C2.80007 4.66 3.81007 3.9 5.50007 3.9C7.28007 3.9 7.94007 4.75 8.00007 6H10.2101C10.1401 4.28 9.09007 2.7 7.00007 2.19V0H4.00007V2.16C2.06007 2.58 0.500068 3.84 0.500068 5.77C0.500068 8.08 2.41007 9.23 5.20007 9.9C7.70007 10.5 8.20007 11.38 8.20007 12.31C8.20007 13 7.71007 14.1 5.50007 14.1C3.44007 14.1 2.63007 13.18 2.52007 12H0.320068C0.440068 14.19 2.08007 15.42 4.00007 15.83V18H7.00007V15.85C8.95007 15.48 10.5001 14.35 10.5001 12.3C10.5001 9.46 8.07007 8.49 5.80007 7.9Z",
    fill: "#2C7BE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.f6eaf93d0986792a82966baf8625feaf.svg";
export { ForwardRef as ReactComponent };